/// <reference path="../typings/index.d.ts" />

namespace App.Docs {
    export class Toc {
        public static inicializar(): void {
            var article = document.querySelector('.docs-article');
            var toc = document.getElementById('docs-toc');

            if (!article || !toc) {
                return;
            }

            var headings = article.querySelectorAll('h2, h3');
            if (!headings.length) {
                toc.style.display = 'none';
                return;
            }

            for (var index = 0; index < headings.length; index++) {
                var heading = headings[index];
                var el = heading as HTMLElement;
                if (!el.id) {
                    el.id = 'docs-secao-' + (index + 1);
                }

                var link = document.createElement('a');
                link.href = '#' + el.id;
                link.textContent = el.textContent || '';
                if (el.tagName === 'H3') {
                    link.style.paddingLeft = '12px';
                }
                toc.appendChild(link);
            }
        }
    }
}

$(document).ready(function () {
    if (document.getElementById('docs-toc')) {
        App.Docs.Toc.inicializar();
    }
});
